import styled, { css } from "styled-components/macro";

export const MessageSectionWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ChatNotFound = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  background: ${(props) => props.theme.colors.bgBody};
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors.text};
  line-height: 21px;
  max-width: 100%;
  width: fit-content;
  align-self: flex-start;
  margin-top: 4px;
  box-shadow: 1px 1px 2px 1px rgb(0 0 0 / 30%);
  & button {
    position: absolute;
    top: 0.1em;
    right: 0.5em;
    cursor: pointer;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    background: transparent;
    font-size: .8rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.text};
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }
`;

export const NewMessageAlert = styled.div`
  position: absolute;
  bottom: 0;
  background: ${(props) => props.theme.colors.text};
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors.place};
  left: calc(50% - 60px);
  z-index: 10;
  opacity: 70%;
  transition: all 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
`;

export const MessageSection = styled.div<{ isPhone?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  & > p {
    margin: 0;
    color: ${(props) => props.theme.colors.textMuted};
  }
`;

export const Loader = styled.div<{color?: string, height?: number, borderWidth?: number}>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: ${(props) => props.height ? props.height : 30}px;
    & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${(props) => props.height ? props.height + 10 : 30}px;
    height: ${(props) => props.height ? props.height + 10 : 30}px;
    margin: 8px;
    border: 3px solid ${(props) => props.color ? props.color : props.theme.colors.text};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => props.color ? props.color : props.theme.colors.text} transparent transparent transparent;
    border-width: ${(props) => props.borderWidth ? props.borderWidth : 3}px;
    }
  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const MessageWrapper = styled.div<{ isMy: boolean; isDel?: boolean }>`
  position: relative;
  background: ${(props) =>
    props.isMy ? props.theme.colors.text : props.theme.colors.bgBody};
  ${(props) =>
    props.isDel &&
    css`
      background: ${(props) => props.theme.colors.textMuted};
    `}

  & > #unread {
    position: absolute;
    bottom: 5px;
    right: 5px;
    background: ${(props) => props.theme.colors.text};
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
  
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 6px;
  max-width: 100%;
  width: fit-content;
  align-self: ${(props) => (props.isMy ? "flex-end" : "flex-start")};
  margin-top: 4px;
  box-shadow: 1px 1px 2px 1px rgb(0 0 0 / 30%);
  position: relative;
  & > p {
    word-break: break-all;
    font-size: 16px;
    margin: 0;
    color: ${(props) =>
    props.isMy ? props.theme.colors.place : props.theme.colors.text};
    line-height: 21px;
    & > span {
      font-size: ${(props) => props.theme.font.sizeMenu};
      color: ${(props) =>
    props.isMy
      ? props.theme.colors.textMuted
      : props.theme.colors.textDimmed};
    }
  }

  ${(props) =>
    props.isMy &&
    css`
      margin-right: 6px;
      & .editMsg {
        position: absolute;
        right: 1px;
        top: 1px;
        background-color: ${(props) => props.theme.colors.place};
        border: 1px solid grey;
        display: none;
        width: 4rem;
        padding: 0 3px;
        text-align: right;
        border-radius: 4px;
      }
      &:hover {
        & .editMsg {
          display: flex;
          justify-content: space-between;
        }
      }
    `}
`;

export const MessageWrapperDlg = styled.div`
  background: ${(props) => props.theme.colors.bgBody};
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors.text};
  line-height: 21px;
  max-width: 100%;
  width: fit-content;
  align-self: flex-start;
  margin-top: 4px;
  margin-right: 6px;
  box-shadow: 1px 1px 2px 1px rgb(0 0 0 / 30%);
`;

export const ButtonGroup = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  height: 100%;
  & button:nth-last-child(1) {
    margin-left: 10px;
  }
`;
